<template>
    <a-modal title="摄像头调起失败" v-model="swichVisible" cancelText="去授权" okText="提交输入内容"
             @ok="handleSubmit">
        <p>1、请允许浏览器获取摄像头权限</p>
        <p>2、或者手动输入主控码或货柜码</p>
        <a-input v-model="form.value" :placeholder="placeholder"/>
    </a-modal>
</template>

<script>
    export default {
        name: "videoDeviceError",
        data() {
            return {
                form: {
                    value: ''
                }
            }

        },
        props: {
            value: Boolean,
            prefix: String,
            placeholder: String
        },
        computed: {
            swichVisible: {
                get() {
                    return this.value
                },
                set(newValue) {
                    this.$emit('input', newValue)
                }
            }
        },

        methods: {
            handleSubmit() {
                this.swichVisible = false;
                this.form.value && this.$emit('submit', this.prefix + this.form.value);
            }
        }
    }
</script>

<style scoped>

</style>